module.exports = __webpack_public_path__ + "static/media/jyoti.5fb5d0f3.jpg";